interface FlashDurationSliderProps {
  value: number;
  onChange: (value: number) => void;
}

const MIN = 1000;
const MAX = 5000;
const RANGE = MAX - MIN;

const FlashDurationSlider = ({ value, onChange }: FlashDurationSliderProps) => {
  const fillPercent = ((value - MIN) / RANGE) * 100;

  return (
    <div
      data-testid="FlashDurationSliderContainer"
      id="FlashDurationSliderContainer"
      className="ml-4 flex flex-shrink-0 items-center gap-3"
    >
      <input
        type="range"
        min={MIN}
        max={MAX}
        step="500"
        value={value}
        onChange={(e) => onChange(Number(e.target.value))}
        className="h-2 w-32 cursor-pointer appearance-none rounded-lg bg-gray-300 accent-orange-500 dark:bg-gray-600"
        style={{
          background: `linear-gradient(to right, rgb(249 115 22) 0%, rgb(249 115 22) ${fillPercent}%, rgb(209 213 219) ${fillPercent}%, rgb(209 213 219) 100%)`,
        }}
      />
      <span className="min-w-[3rem] text-sm font-medium text-gray-700 dark:text-gray-300">
        {(value / 1000).toFixed(1)}s
      </span>
    </div>
  );
};

export default FlashDurationSlider;
